module.exports = __webpack_public_path__ + "static/media/pickupIcon.4165afa8.svg";